import { KnockTypes } from '../Knock/KnockTypes'
import TextCell from './TextCell'
import BooleanCell from './BooleanCell'
import RegistrationCell from './RegistrationCell'
import DateTimeCell from './DateTimeCell'
import CurrencyCell from './CurrencyCell'
import HexColourCell from './HexColourCell'
import ImageCell from './ImageCell'
import TextArrayCell from './TextArrayCell'
import RawMessageCell from './RawMessageCell'
import LambdaErrorCell from './LambdaErrorCell'
import CountryCodeCell from './CountryCodeCell'
import DateCell from './DateCell'

const KnockTypeCellMap = {
  [KnockTypes.Boolean]: BooleanCell,
  [KnockTypes.Date]: DateCell,
  [KnockTypes.DateTime]: DateTimeCell,
  [KnockTypes.EnumArray]: TextArrayCell,
  [KnockTypes.EnumCountryCode]: CountryCodeCell,
  [KnockTypes.HexColour]: HexColourCell,
  [KnockTypes.Image]: ImageCell,
  [KnockTypes.Money]: CurrencyCell,
  [KnockTypes.RawMessage]: RawMessageCell,
  [KnockTypes.LambdaError]: LambdaErrorCell,
  [KnockTypes.Registration]: RegistrationCell,
  [KnockTypes.String]: TextCell
}

export default KnockTypeCellMap
